/**
 * ContentRepository module
 *
 * This module create shortcut with a request
 * to the API
 *
 */

'use strict';

const RequestHandler = require('./../../../core/requestHandler');


module.exports.findAll = function(context) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.read('langs' + (context ? `?context=${context}` : ''));

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.enable = function(lang) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.update('langs/enable/' + lang);

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.disable = function(lang) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.update('langs/disable/' + lang);

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.setDefault = function(lang) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.update('langs/define-default/' + lang);

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};
